__turbopack_context__.v({
  "fadeInItems": "Layout-module__fmZ1UG__fadeInItems",
  "main": "Layout-module__fmZ1UG__main",
  "spacing--lg": "Layout-module__fmZ1UG__spacing--lg",
  "spacing--md": "Layout-module__fmZ1UG__spacing--md",
  "spacing--sm": "Layout-module__fmZ1UG__spacing--sm",
  "spacing--xl": "Layout-module__fmZ1UG__spacing--xl",
  "spacing--xs": "Layout-module__fmZ1UG__spacing--xs",
  "spacing--xxl": "Layout-module__fmZ1UG__spacing--xxl",
  "spacing--xxs": "Layout-module__fmZ1UG__spacing--xxs",
  "spacing--xxxl": "Layout-module__fmZ1UG__spacing--xxxl",
  "spacing--xxxs": "Layout-module__fmZ1UG__spacing--xxxs",
});
